import {
  Grid,
  Paper,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from "@material-ui/core";
import React, { useContext } from "react";

import Button from "./Button";
import { LangContext } from "../context/LangContext";
import { UserContext } from "../context/UserContext";
import { accessControl } from "../constants/enums";
import { hasUserAccess } from "../utils";
import translations from "../assets/json/translations.json";
import { useHistory } from "react-router-dom";
import useNotifier from "../hooks/useNotifier";

interface IProps {
  samplingMenu?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      height: `calc(100vh - ${theme.dimensions.navbarHeight}px)`,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    paper: {
      flex: 1,
      padding: theme.spacing(3),
      margin: theme.spacing(3),
      textAlign: "center",
      maxWidth: theme.dimensions.boxWidth,
    },
    typographyTitle: {
      padding: theme.spacing(2),
    },
  })
);

const Home: React.FC<IProps> = ({ samplingMenu = true }) => {
  const { notifyError } = useNotifier();
  const classes = useStyles({});
  const history = useHistory();
  const [user] = useContext(UserContext);
  const [lang] = useContext(LangContext);

  if ((window as any).logPrinterError === undefined) {
    (window as any).logPrinterError = notifyError;
  }

  return (
    <div className={classes.root}>
      <Paper elevation={2} className={classes.paper}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Typography className={classes.typographyTitle} variant="h4">
              {translations.actions[lang]}
            </Typography>
          </Grid>
          {renderSamplingItems()}
        </Grid>
      </Paper>
    </div>
  );

  function renderSamplingItems() {
    return (
      <React.Fragment>
        {hasUserAccess(accessControl.NEW_SCREENING_REQUESTS, user) && (
          <Grid item xs={12} sm={12}>
            <Button
              fullWidth
              onClick={() => history.push("/new-screening-requests")}
            >
              {translations.newScreeningRequests[lang]}
            </Button>
          </Grid>
        )}
        {(hasUserAccess(accessControl.SENT_SCREENING_REQUESTS_FULL_ACCESS, user) 
          || hasUserAccess(accessControl.SENT_SCREENING_REQUESTS_PATHOLOGISTS, user)) && (
          <Grid item xs={12} sm={12}>
            <Button
              fullWidth
              onClick={() => history.push("/sent-screening-requests")}
            >
              {translations.sentScreeningRequests[lang]}
            </Button>
          </Grid>
        )}
        {hasUserAccess(accessControl.SCREENING_REQUESTS_OVERVIEW, user) && (
          <Grid item xs={12} sm={12}>
            <Button
              fullWidth
              onClick={() => history.push("/screening-requests-overview")}
            >
              {translations.screeningRequestsOverview[lang]}
            </Button>
          </Grid>
        )}
        {hasUserAccess(accessControl.SUPER_ADMIN, user) && (
          <Grid item xs={12} sm={12}>
            <Button fullWidth onClick={() => history.push("/access-control")}>
              {translations.accessControl[lang]}
            </Button>
          </Grid>
        )}
      </React.Fragment>
    );
  }
};

export default Home;
